import { Button, Modal } from 'react-bootstrap';

export const IdleTimeOutModal = ({showModal, onLogout, countdown, onContinue}) => {
    return (
        <Modal show={showModal} onHide={onContinue}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>Session Timeout</Modal.Title>
            </Modal.Header>
            <Modal.Body>Your session will expire in {countdown} seconds.</Modal.Body>
            <Modal.Body>Do you want to stay instead?</Modal.Body>
            <Modal.Body>Please click on the Stay button below to continue.</Modal.Body>
            <Modal.Body>If not, the session will expire automatically.</Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={onLogout}>
                Logout
            </Button>
            <Button variant="primary" onClick={onContinue}>
                Stay
            </Button>
            </Modal.Footer>
        </Modal>
    )
}